import { type ConsentState, onConsentChange, readConsentState } from '@nt/consent'
import { useEffect, useState } from 'react'

function readNow(): ConsentState {
  return readConsentState(typeof document === 'undefined' ? '' : document.cookie)
}

/**
 * The visitor's cookie consent (@nt/consent): whether they are in a consent
 * region (the Worker's `nt_geo` cookie), their stored choice and what applies
 * now. Follows every later save on this page, even if the browser refused the
 * cookie, because the choice travels in the event itself.
 */
export function useConsentState(): ConsentState {
  const [state, setState] = useState(readNow)
  useEffect(
    () =>
      onConsentChange(
        (choice) => setState((previous) => ({ ...previous, choice, effective: choice, showBanner: false })),
        window,
      ),
    [],
  )
  return state
}
